import getSearchTerm from 'redux/modules/search/selectors/get-search-term';
import { addProductDimension } from 'redux/middleware/custom-dimensions/dimensions/actions';

const addProductSearchTerm = state =>
  getSearchTerm(state) ? addProductDimension('search_term', getSearchTerm(state)) : null;

export default addProductSearchTerm;
